export default "__VITE_ASSET__c4825f34__"